import type { TReduxActions } from '../../types/redux';

export const PUIDS_RESPONSE = 'afox/PUIDS_RESPONSE';

export type AdfoxState = {
  puids: object;
};

const initialState: AdfoxState = {
  puids: {},
};

export function adfoxReducer(state = initialState, action: TReduxActions): AdfoxState {
  switch (action.type) {
    case PUIDS_RESPONSE:
      return {
        ...state,
        puids: action.payload,
      };

    default:
      return state;
  }
}

export interface IAdfoxPuidsSuccessAction {
  type: typeof PUIDS_RESPONSE;
  payload: object;
}

export function setAdfoxPuids(puids: object): IAdfoxPuidsSuccessAction {
  return {
    type: PUIDS_RESPONSE,
    payload: puids,
  };
}
